import ScratchOverlay from '@CS/assets/overlay.png';
import ScratchBrush from '@CS/assets/brush.png';

import WheelArrow from '@CS/assets/arrow.png';
import WheelIcon from '@CS/assets/icon.png';

import Lottie from '@CS/assets/loader.json';
import Gif from '@CS/assets/loader.gif';

import Large from '@CS/assets/large.png';
import Small from '@CS/assets/small.png';

import x1 from '@CS/assets/1x.jpg';
import x2 from '@CS/assets/2x.jpg';
import x3 from '@CS/assets/3x.jpg';

export const Particles = [Large, Small];

export const Sizes = { x1, x2, x3 };

export const Scratch = {
  overlay: ScratchOverlay,
  brush: ScratchBrush
};

export const Loader = {
  lottie: Lottie,
  gif: Gif
};

export const Wheel = {
  arrow: WheelArrow,
  icon: WheelIcon
};
